import getStore from '../store';
import { ClientItemId } from 'owa-client-ids';

export default function getNotesEditorViewState(id: ClientItemId) {
    return getStore().meetingIdToNotesViewStateMap.get(id.Id);
}
